import {
    getCollegeRankingFilterRepo,
    getCollegeRankingListRepo,
    postCollegeRankingListRepo,
    getStudyabroadCollegeRankingDetailRepo,
    getCourseRankingDetailRepo,
    putCollegeRankingDetailUpdateRepo,
    getCourseRankingListRepo,
    postCourseRankingListRepo,
    putCourseRankingDetailRepo,
    getCollegeRankingFilterCollegeRepo,
    getCourseRankingFilterCourseRepo,
} from "../repositories/rankingPanel/studyabroadCollegeRanking";
import { createSlice } from "@reduxjs/toolkit";

const studyabroadCollegeRankingSlice = createSlice({
    name: "studyabroadRankingPannelReducer",
    initialState: {

        countryFilterLoading: null,
        countryFilter: null,
        countryFilterError: null,
        
        collegeFilterLoading: null,
        collegeFilter: null,
        collegeFilterError: null,

        courseFilterLoading: null,
        courseFilter: null,
        courseFilterError: null,

        authorityFilterLoading: null,
        authorityFilter: null,
        authorityFilterError: null,

        rankingTypeFilterLoading: null,
        rankingTypeFilter: null,
        rankingTypeFilterError: null,

        streamFilterLoading: null,
        streamFilter: null,
        streamFilterError: null,

        yearFilterLoading: null,
        yearFilter: null,
        yearFilterError: null,

        collegeRankingListLoading:null,
        collegeRankingList:null,
        collegeRankingListError:null,

        postRankingListLoading: null,
        postRankingList: null,
        postRankingListError: null,

        collegeRankingDetailLoading:null,
        collegeRankingDetail:null,
        collegeRankingDetailError:null,

        collegeRankingDetailUpdateLoading:null,
        collegeRankingDetailUpdate:null,
        collegeRankingDetailUpdate_Error:null,

        courseRankingListLoading:null,
        courseRankingList:null,
        courseRankingListError:null,

        postCourseRankingListLoading: null,
        postCourseRankingList: null,
        postCourseRankingListError: null,

        courseRankingDetailLoading:null,
        courseRankingDeatil:null,
        courseRankingDetailError:null,

        putCourseRankingDetailLoading:null,
        putCourseRankingDetail:null,
        putCourseRankingDetailError:null,

        //  for duplicate college 
        FilterCollegeLoading: null,
        FilterCollege: null,
        FilterCollegeError: null,

        //  for duplicate courses
        FilterCourseLoading: null,
        FilterCourse: null,
        FilterCourseError: null,
        message:null,

    },
    reducers: {

        getCountryFilterLoading(state, action) {
            return {
                ...state,
                countryFilterLoading: true,
            };
        },
        getCountryFilterSuccess(state, action) {
            return {
                ...state,
                countryFilterLoading: false,
                countryFilter: action.payload,
            };
        },
        getCountryFilterFailure(state, action) {
            return {
                ...state,
                countryFilterLoading: false,
                countryFilterError: action.payload,
            };
        },

        getCollegeFilterLoading(state, action) {
            return {
                ...state,
                collegeFilterLoading: true,
            };
        },
        getCollegeFilterSuccess(state, action) {
            return {
                ...state,
                collegeFilterLoading: false,
                collegeFilter: action.payload,
            };
        },
        getCollegeFilterFailure(state, action) {
            return {
                ...state,
                collegeFilterLoading: false,
                collegeFilterError: action.payload,
            };
        },
        clearCollegeFilter(state, action) {
            return {
                ...state,
                collegeFilterLoading: false,
                collegeFilter: null,
            };
        },
        getCourseFilterLoading(state, action) {
            return {
                ...state,
                courseFilterLoading: true,
            };
        },
        getCourseFilterSuccess(state, action) {
            return {
                ...state,
                courseFilterLoading: false,
                courseFilter: action.payload,
            };
        },
        getCourseFilterFailure(state, action) {
            return {
                ...state,
                courseFilterLoading: false,
                courseFilterError: action.payload,
            };
        },

        clearCourseFilter(state, action) {
            return {
                ...state,
                courseFilterLoading: false,
                courseFilter: null,
            };
        },

        getAuthorityFilterLoading(state, action) {
            return {
                ...state,
                authorityFilterLoading: true,
            };
        },
        getAuthorityFilterSuccess(state, action) {
            return {
                ...state,
                authorityFilterLoading: false,
                authorityFilter: action.payload,
            };
        },
        getAuthorityFilterFailure(state, action) {
            return {
                ...state,
                authorityFilterLoading: false,
                authorityFilterError: action.payload,
            };
        },

        getRankingTypeFilterLoading(state, action) {
            return {
                ...state,
                rankingTypeFilterLoading: true,
            };
        },
        getRankingTypeFilterSuccess(state, action) {
            return {
                ...state,
                rankingTypeFilterLoading: false,
                rankingTypeFilter: action.payload,
            };
        },
        getRankingTypeFilterFailure(state, action) {
            return {
                ...state,
                rankingTypeFilterLoading: false,
                rankingTypeFilterError: action.payload,
            };
        },

        getStreamFilterLoading(state, action) {
            return {
                ...state,
                streamFilterLoading: true,
            };
        },
        getStreamFilterSuccess(state, action) {
            return {
                ...state,
                streamFilterLoading: false,
                streamFilter: action.payload,
            };
        },
        getStreamFilterFailure(state, action) {
            return {
                ...state,
                streamFilterLoading: false,
                streamFilterError: action.payload,
            };
        },
        
        getYearFilterLoading(state, action) {
            return {
                ...state,
                yearFilterLoading: true,
            };
        },
        getYearFilterSuccess(state, action) {
            return {
                ...state,
                yearFilterLoading: false,
                yearFilter: action.payload,
            };
        },
        getYearFilterFailure(state, action) {
            return {
                ...state,
                yearFilterLoading: false,
                yearFilterError: action.payload,
            };
        },
        
        getCollegeRankingListLoading(state, action) {
            return {
                ...state,
                collegeRankingListLoading: true,
            };
        },
        getCollegeRankingListSuccess(state, action) {
            return {
                ...state,
                collegeRankingListLoading: false,
                collegeRankingList: action.payload,
            };
        },
        getCollegeRankingListFailure(state, action) {
            return {
                ...state,
                collegeRankingListLoading: false,
                collegeRankingListError: action.payload,
            };
        },

        postCollegeRankingListLoading(state, action){
            return {
                ...state,
                postRankingListLoading: true,
                message:null,
            };
        },
        postCollegeRankingListSuccess(state, action) {
            return {
                ...state,
                postRankingListLoading: false,
                postRankingList:action.payload,
                message: "College Rank Added Successfully",
            };
        },
        postCollegeRankingListFailure(state, action) {
            return {
                ...state,
                postRankingListLoading: false,
                postRankingListError:action.payload,
                message: action.payload,
            };
        },

        getCollegeRankingDetailLoading(state, action) {
            return {
                ...state,
                collegeRankingDetailLoading: true,
            };
        },
        getCollegeRankingDetailSuccess(state, action) {
            return {
                ...state,
                collegeRankingDetailLoading: false,
                collegeRankingDetail: action.payload,
            };
        },
        getCollegeRankingDetailFailure(state, action) {
            return {
                ...state,
                collegeRankingDetailLoading: false,
                collegeRankingDetailError: action.payload,
            };
        },

        putCollegeRankingDetailUpdateLoading(state, action) {
            return {
                ...state,
                collegeRankingDetailUpdateLoading: true,
                message: null,
            };
        },
        putCollegeRankingDetailUpdateSuccess(state, action) {
            return {
                ...state,
                collegeRankingDetailUpdateLoading: false,
                collegeRankingDetailUpdate: action.payload,
                message: "College Rank updated Successfully",
            };
        },
        putCollegeRankingDetailUpdateFailure(state, action) {
            return {
                ...state,
                collegeRankingDetailUpdateLoading: false,
                collegeRankingDetailUpdateError: action.payload,
                message: action.payload,
            };
        },

        getCourseRankingListLoading(state, action) {
            return {
                ...state,
                courseRankingListLoading: true,
            };
        },
        getCourseRankingListSuccess(state, action) {
            return {
                ...state,
                courseRankingListLoading: false,
                courseRankingList: action.payload,
            };
        },
        getCourseRankingListFailure(state, action) {
            return {
                ...state,
                courseRankingListLoading: false,
                courseRankingListError: action.payload,
            };
        },
        postCourseRankingListLoading(state, action) {
            return {
                ...state,
                postCourseRankingListLoading: true,
                message: null,
            };
        },
        postCourseRankingListSuccess(state, action) {
            return {
                ...state,
                postCourseRankingListLoading: false,
                postCourseRankingList: action.payload,
                message: "Course Rank Added Successfully",
            };
        },
        postCourseRankingListFailure(state, action) {
            return {
                ...state,
                postCourseRankingListLoading: false,
                postCourseRankingListError: action.payload,
                message: action.payload,
            };
        },
        getCourseRankingDetailLoading(state, action) {
            return {
                ...state,
                courseRankingDeatilLoading: true,
            };
        },
        getCourseRankingDetailSuccess(state, action) {
            return {
                ...state,
                courseRankingDeatilLoading: false,
                courseRankingDeatil: action.payload,
            };
        },
        getCourseRankingDetailFailure(state, action) {
            return {
                ...state,
                courseRankingDeatilLoading: false,
                courseRankingDeatil: action.payload,
            };
        },
        putCourseRankingDetailLoading(state, action) {
            return {
                ...state,
                putCourseRankingDetailLoading: true,
                message: null,
            };
        },
        putCourseRankingDetailSuccess(state, action) {
            return {
                ...state,
                putCourseRankingDetalLoading: false,
                putCourseRankingDetail: action.payload,
                message: "Course Rank updated Successfully",
            };
        },
        putCourseRankingDetailFailure(state, action) {
            return {
                ...state,
                putCourseRankingDetalLoading: false,
                putCourseRankingDetailError: action.payload,
                message: action.payload,
            };
        },
        
        // duplicate college
        getFilterCollegeLoading(state, action) {
            return {
                ...state,
                FilterCollegeLoading: true,
            };
        },
        getFilterCollegeSuccess(state, action) {
            return {
                ...state,
                FilterCollegeLoading: false,
                FilterCollege: action.payload,
            };
        },
        getFilterCollegeFailure(state, action) {
            return {
                ...state,
                FilterCollegeLoading: false,
                FilterCollegeError: action.payload,
            };
        },

        // duplicate courses
        getFilterCourseLoading(state, action) {
            return {
                ...state,
                FilterCourseLoading: true,
            };
        },
        getFilterCourseSuccess(state, action) {
            return {
                ...state,
                FilterCourseLoading: false,
                FilterCourse: action.payload,
            };
        },
        getFilterCourseFailure(state, action) {
            return {
                ...state,
                FilterCourseLoading: false,
                FilterCourseError: action.payload,
            };
        },

        clearMessage(state, action) {
            return {
                ...state,
                message: null,
                postRankingList:null,
                postRankingListError:null,
                collegeRankingDetailUpdate:null,
                collegeRankingDetailUpdateError:null,
                postCourseRankingList:null,
                postCourseRankingListError:null,
                putCourseRankingDetail:null,
                putCourseRankingDetailError:null,
            }
        },

        clearDetailData(state, action) {
            return {
                ...state,
                collegeRankingDetail:null,
                courseRankingDeatil:null,
            }
        }
        
    },
});
export const {
    getCountryFilterLoading,
    getCountryFilterSuccess,
    getCountryFilterFailure,

    getCollegeFilterLoading,
    getCollegeFilterSuccess,
    getCollegeFilterFailure,
    clearCollegeFilter,

    getCourseFilterLoading,
    getCourseFilterSuccess,
    getCourseFilterFailure,
    clearCourseFilter,

    getAuthorityFilterLoading,
    getAuthorityFilterSuccess,
    getAuthorityFilterFailure,

    getRankingTypeFilterLoading,
    getRankingTypeFilterSuccess,
    getRankingTypeFilterFailure,

    getStreamFilterLoading,
    getStreamFilterSuccess,
    getStreamFilterFailure,

    getYearFilterLoading,
    getYearFilterSuccess,
    getYearFilterFailure,

    getCollegeRankingListLoading,
    getCollegeRankingListSuccess,
    getCollegeRankingListFailure,

    postCollegeRankingListLoading,
    postCollegeRankingListSuccess,
    postCollegeRankingListFailure,

    getCollegeRankingDetailLoading,
    getCollegeRankingDetailSuccess,
    getCollegeRankingDetailFailure,

    putCollegeRankingDetailUpdateLoading,
    putCollegeRankingDetailUpdateSuccess,
    putCollegeRankingDetailUpdateFailure,

    getCourseRankingListLoading,
    getCourseRankingListSuccess,
    getCourseRankingListFailure,

    postCourseRankingListLoading,
    postCourseRankingListSuccess,
    postCourseRankingListFailure,

    getCourseRankingDetailLoading,
    getCourseRankingDetailSuccess,
    getCourseRankingDetailFailure,

    putCourseRankingDetailLoading,
    putCourseRankingDetailSuccess,
    putCourseRankingDetailFailure,
    
    // duplicate college 
    getFilterCollegeLoading,
    getFilterCollegeSuccess,
    getFilterCollegeFailure,

    // duplicate course
    getFilterCourseLoading,
    getFilterCourseSuccess,
    getFilterCourseFailure,

    clearMessage,
    clearDetailData,

} = studyabroadCollegeRankingSlice.actions;

export const getStudyabroadCountryFilter = (params) => {
    return async (dispatch) => {
        dispatch(getCountryFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCountryFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCountryFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadCollegeFilter = (params) => {
    return async (dispatch) => {
        dispatch(getCollegeFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCollegeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCollegeFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadCourseFilter = (params) => {
    return async (dispatch) => {
        dispatch(getCourseFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCourseFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCourseFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadAuthorityFilter = (params) => {
    return async (dispatch) => {
        dispatch(getAuthorityFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getAuthorityFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getAuthorityFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadRankingTypeFilter = (params) => {
    return async (dispatch) => {
        dispatch(getRankingTypeFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getRankingTypeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getRankingTypeFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadStreamFilter = (params) => {
    return async (dispatch) => {
        dispatch(getStreamFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getStreamFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getStreamFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadYearFilter = (params) => {
    return async (dispatch) => {
        dispatch(getYearFilterLoading());
        await getCollegeRankingFilterRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getYearFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getYearFilterFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadCollegeList = (params) => {
    return async (dispatch) => {
        dispatch(getCollegeRankingListLoading());
        await getCollegeRankingListRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCollegeRankingListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCollegeRankingListFailure(error.response?.data?.message));
                }
            });
    };
};

export const postStudyabroadCollegeList = (data) => {
    return async (dispatch) => {
        dispatch(postCollegeRankingListLoading());
        await postCollegeRankingListRepo(data)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(postCollegeRankingListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postCollegeRankingListFailure(error.response?.data?.message));
                }
            });
    };
};

export const getCollegeRankingDetail = (params) => {
    return async (dispatch) => {
        dispatch(getCollegeRankingDetailLoading());
        await getStudyabroadCollegeRankingDetailRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCollegeRankingDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCollegeRankingDetailFailure(error.response?.data?.message));
                }
            });
    };
};

export const putCollegeRankingDetailUpdate = (data) => {
    return async (dispatch) => {
        dispatch(putCollegeRankingDetailUpdateLoading());
        await putCollegeRankingDetailUpdateRepo(data)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(putCollegeRankingDetailUpdateSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putCollegeRankingDetailUpdateFailure(error.response?.data?.message));
                }
            });
    };
};

export const getStudyabroadCourseList = (params) => {
    return async (dispatch) => {
        dispatch(getCourseRankingListLoading());
        await getCourseRankingListRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCourseRankingListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCourseRankingListFailure(error.response?.data?.message));
                }
            });
    };
};

export const postStudyabroadCourseList = (data) => {
    return async (dispatch) => {
        dispatch(postCourseRankingListLoading());
        await postCourseRankingListRepo(data)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(postCourseRankingListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postCourseRankingListFailure(error.response?.data?.message));
                }
            });
    };
};

export const getCourseRankingDetail = (params) => {
    return async (dispatch) => {
        dispatch(getCourseRankingDetailLoading());
        await getCourseRankingDetailRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getCourseRankingDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCourseRankingDetailFailure(error.response?.data?.message));
                }
            });
    };
};

export const putCourseRankingDetailUpdate = (data) => {
    return async (dispatch) => {
        dispatch(putCourseRankingDetailLoading());
        await putCourseRankingDetailRepo(data)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(putCourseRankingDetailSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putCourseRankingDetailFailure(error.response?.data?.message));
                }
            });
    };
};

// for duplicate college
export const getStudyabroadFilterCollege = (params) => {
    return async (dispatch) => {
        dispatch(getFilterCollegeLoading());
        await getCollegeRankingFilterCollegeRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getFilterCollegeSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getFilterCollegeFailure(error.response?.data?.message));
                }
            });
    };
};

// for duplicate courses
export const getFilterCourse = (params) => {
    return async (dispatch) => {
        dispatch(getFilterCourseLoading());
        await getCourseRankingFilterCourseRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getFilterCourseSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getFilterCourseFailure(error.response?.data?.message));
                }
            });
    };
};
export default studyabroadCollegeRankingSlice.reducer;
